import ResetPassword from "src/components/features/forgotPassword/resetPassword";

const ResetPasswordPage = () => <ResetPassword />;

export default ResetPasswordPage;
